/* Count blog post CTAs, and send to Google Analytics */

document.addEventListener('DOMContentLoaded', () => {
	/* Get CTAs within blog post content area */
	const contentArea = document.querySelector('main article.content');

	if (contentArea) {
		const ctas = contentArea.querySelectorAll('[analytics-track-event="blog-post-cta"]');

		/* Push to dataLayer */
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			ctaCount: ctas.length,
		});
	}
});
